import {
  EuiText,
  EuiFlexGroup,
  EuiFlexItem,
  EuiButton
} from "@elastic/eui";
import LanguageSwitcher from "./LanguageSwitcher";

import { useTranslation } from 'react-i18next';

export function SolarHeader() {
  const { t } = useTranslation();
  return (
    <div style={{ padding: "15px 15px 30px 15px" }} className="container align-items-baseline pb-lg-3 pb-sm-0 position-relative">
      <div className="euiFlexGroup euiFlexGroup--gutterSmall euiFlexGroup--justifyContentSpaceBetween euiFlexGroup--directionRow euiFlexGroup--responsive ">

        <div className="euiFlexItem euiFlexItem--flexGrowZero">
          <a className="navbar-brand pb-0" href="/">
                <img className="navbar-brand-item light-mode-item img-thumbnail" style={{height:"50px"}} src="/EihpTheme/images/solar_adria_logo.png" alt="SolarAdria logo"/>
          </a>
        </div>
        <div className="euiFlexItem">

        </div>
        <div className="euiFlexItem euiFlexItem--flexGrowZero">
            <div className="euiFlexGroup euiFlexGroup--responsive ">
              <div className="euiFlexItem euiFlexItem--flexGrowZero">
                <a className="euiButtonEmpty euiButtonEmpty--primary" type="button" href="/">
                  <span className="euiButtonEmpty__content">
                    <span className="euiButtonEmpty__text" style={{fontWeight:"bold", textTransform:"uppercase", color:"black", float:"right"}}>{t('Home')}</span>
                  </span>
                </a>
              </div>

              <div className="euiFlexItem euiFlexItem--flexGrowZero">
                <a className="euiButtonEmpty euiButtonEmpty--primary" type="button" href="/members/portal">
                  <span className="euiButtonEmpty__content">
                    <span className="euiButtonEmpty__text" style={{fontWeight:"bold", textTransform:"uppercase", color:"black", float:"right"}}>{t('Portal')}</span>
                  </span>
                </a>
              </div>
            </div>
        </div>
        <LanguageSwitcher></LanguageSwitcher>
      </div>
      
    </div>
  );
}
